import OtherRetirementAccounts from "../OtherRetirementAccounts";

export default function GoalsOtherRetirementAccounts({
  advanceScreen,
  previousScreen,
  validation,
  updateValidation,
  screen,
}) {
  return <OtherRetirementAccounts
    advanceScreen={advanceScreen}
    previousScreen={previousScreen}
    validation={validation}
    updateValidation={updateValidation}
    screen={screen}
  />
}
